import useStoredEventMarkers from './useStoredEventMarkers';

// Key level events (DWLF-333) as chart markers: the nightly job stores them
// against the same levels the chart draws, so the markers and the guides agree.
// Kinds that mark something happening at a level (DWLF-447); approached and expired are
// excluded as the noisiest and least actionable.
export const KEY_LEVEL_MARKER_TYPES = [
  'keyLevel.formed',
  'keyLevel.tested',
  'keyLevel.rejected',
  'keyLevel.broken',
  'keyLevel.retested',
  'keyLevel.flipped',
  'keyLevel.reclaimed',
];

const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') {return null;}
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

// /v2/events row → the library shape registerEvents takes ({ id, t, payload }).
export const toKeyLevelLibraryEvent = (stored) => {
  if (!stored || typeof stored.eventType !== 'string' || !stored.eventType.startsWith('keyLevel.')) {return null;}
  const t = Date.parse(stored.eventTimestamp ?? stored.date);
  const price = toNumberOrNull(stored.keyLevel?.levelPrice ?? stored.price);
  if (!Number.isFinite(t) || price === null) {return null;}
  const keyLevel = stored.keyLevel || {};
  const kind = keyLevel.kind || stored.eventType.slice('keyLevel.'.length);
  return {
    id: stored.eventType,
    name: `Key level ${kind}${keyLevel.direction && keyLevel.direction !== 'neutral' ? ` (${keyLevel.direction})` : ''}`,
    description: keyLevel.role ? `${keyLevel.role} at ${price}` : `level at ${price}`,
    t,
    payload: { ...keyLevel, price },
  };
};

export default function useBackendKeyLevelEvents(symbol) {
  return useStoredEventMarkers(symbol, { eventTypes: KEY_LEVEL_MARKER_TYPES, toLibraryEvent: toKeyLevelLibraryEvent, label: 'key level' });
}
